module.exports = __webpack_public_path__ + "static/media/6. Speaker Smita Kuriakose.84672df4.png";